import { Link } from "react-router-dom";

export default function AboutTeaser() {
  return (
    <section className="w-full px-4 md:px-8 pb-16 md:pb-20">
      <div className="mx-auto max-w-[1440px]">
        <div className="relative overflow-hidden rounded-lg bg-primary-900 px-6 py-10 md:px-12 md:py-14">
          <div className="absolute -right-16 -top-16 h-64 w-64 rounded-full bg-secondary-500/15"></div>
          <div className="absolute -bottom-20 left-1/3 h-56 w-56 rounded-full bg-accent-500/10"></div>
          <div className="relative z-10 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-end">
            <div className="lg:col-span-7">
              <p className="text-[10px] tracking-[0.28em] text-primary-200">ABOUT SUNDAY CINEMA</p>
              <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
                我们只做一件事：<br className="hidden md:block" />
                帮你更快找到想看的那部片。
              </h2>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-primary-100/80">
                长日光阴是一个影视资讯与资源推荐门户。我们用清晰的分类、稳定的筛选和克制的推荐，替代漫无目的的翻找。所有作品资料均为演示内容，不提供播放与下载。
              </p>
            </div>
            <div className="lg:col-span-5">
              <div className="grid grid-cols-3 gap-3">
                {[
                  { value: "24", label: "精选作品" },
                  { value: "2", label: "主分类" },
                  { value: "6", label: "资讯栏目" },
                ].map((stat) => (
                  <div key={stat.label} className="rounded-lg bg-primary-950/40 p-3 text-center md:p-4">
                    <p className="font-heading text-2xl font-bold text-secondary-400">{stat.value}</p>
                    <p className="mt-1 text-[11px] text-primary-200">{stat.label}</p>
                  </div>
                ))}
              </div>
              <Link
                to="/about"
                className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-medium text-primary-950 whitespace-nowrap transition-colors cursor-pointer hover:bg-secondary-400"
              >
                了解长日光阴
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}